import EventManager from "../../../store/sqftEventManager";
import workspace from "../../workspace";
import config from "../../../store/sqftConfig";
import {getPointField} from "../../../../../helpers/sqftHelper";
import Movable from "./../mixin/movable";
import COLOR_THEMES from "../../../store/colorThemes";
import PointV2, {CORE_POINT_LAYOUTS} from "../../shapes/pointV2";
import RenderFigures from "../../../helpers/renderFigures";

export default class Box {

  design = {
    fillStyle: '#6A6A6A',
    fillStyleDelete: 'rgba(208,1,27,0.3)', //'rgba(253,2,33, 0.5)',
    strokeStyle: COLOR_THEMES[config.activeTheme].primary,
    lineWidth: 1,
    borderRadius: 10,
    shadowColor: '#eeeeee',
    shadowBlur: 15,
    minimumDepth: 4,
    minimumWidth: 15,
    width: 50,
    height: 10
  };
  params = {
    isCenteredByY: false
  };
  points = {};
  children = [];
  _mixin = {
    movable: null
  };

  constructor(pos, design) {
    this.design = Object.assign(this.design, design);

    this.mixin.movable = new Movable(pos.x, pos.y, this.design.width, this.design.height, EventManager.priorities.SEGMENT, this);
    this.initPoints();
    this.initEvents();
  }

  initEvents() {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render.bind(this),
      this,
      EventManager.priorities.BOX
    );

    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp.bind(this),
      this,
      EventManager.priorities.SEGMENT
    );
  }

  delete() {
    this.deleteEvents();
    workspace.textBoxManager.removeBox(this);
  }

  deregisterEvents = () => {
    EventManager.removeEvent(this);
    if (this.mixin.movable) {
      this.mixin.movable.deregisterEvents();
    }
    for (const point in this.points) {
      if (this.points.hasOwnProperty(point)) {
        this.points[point].deregisterEvents();
      }
    }
    this.isHidden = true;
  }

  reInitEvents = () => {
    this.initEvents();
    if (this.mixin.movable) {
      this.mixin.movable.reInitEvents();
    }
    for (const point in this.points) {
      if (this.points.hasOwnProperty(point)) {
        this.points[point].reInitEvents();
      }
    }
    this.isHidden = true;
  }

  deleteEvents() {
    EventManager.resetCursor(this);
    EventManager.removeEvent(this);
    EventManager.removeEvent(this.mixin.movable);

    for(let child of this.children) {
      child.delete();
    }

    for (const point in this.points) {
      if (this.points.hasOwnProperty(point)) {
        this.points[point].delete();
      }
    }
  }

  get width() {
    return this.design.width;
  }

  set width(value) {
    this.design.width = value;
  }

  get height() {
    return this.design.height;
  }

  set height(value) {
    this.design.height = value;
  }

  get mixin() {
    return this._mixin;
  }

  set mixin(value) {
    this._mixin = value;
  }

  get posX() {
    return this.mixin.movable.posX;
  }

  get posY() {
    return this.mixin.movable.posY;
  }

  set posX(value) {
    this.mixin.movable.posX = value;
  }

  set posY(value) {
    this.mixin.movable.posY = value;
  }

  initPoints() {
    let point;

    // 0  1  2
    // 3     4
    // 5  6  7

    let pointsParams = [
      // {x: 0, y: 0}, // {x: this.posX, y: this.posY},
      // {x: this.design.width / 2, y: 0},
      // {x: this.design.width, y: 0},
      // {x: 0, y: this.design.height / 2},
      {id: 'p4', x: this.design.width, y: this.design.height / 2, isCenteredByY: true, isResizedByPoint: true, isScaledByPoint: false, radius: 10, layout: CORE_POINT_LAYOUTS.ear},
      // {x: 0, y: this.design.height},
      // {x: this.design.width / 2, y: this.design.height},
      {id: 'p7', x: this.design.width, y: this.design.height, isCenteredByY: true, isResizedByPoint: false, isScaledByPoint: true, radius: 10, layout: CORE_POINT_LAYOUTS.resize}
    ];
    for (let [i, pointParams] of pointsParams.entries()) {
      void i;
      let pointState = {
        priority: EventManager.priorities.BOX_POINT,
        movable: true,
        isCenteredByY: pointParams.isCenteredByY,
        isResizedByPoint: pointParams.isResizedByPoint,
        isScaledByPoint: pointParams.isScaledByPoint,
        isVisibleOnHover: true
      };
      let pointDesign = {
        radius: pointParams.radius,
        lineWidth: 1,
        layout: pointParams.layout
      };
      point = new PointV2(pointParams.x, pointParams.y, this, pointState, pointDesign);
      point.isResizedByPoint = true;

      this.points[pointParams.id] = point;
    }
  }

  getOffset = function() {
    let self = this;

    return getPointField(self.posX, self.posY);
  };

  getPosition = function() {
    let self = this;

    return {x: self.posX, y: self.posY};
  };

  getPointField = function(posX, posY) {
    let fieldWidth = config.fieldWidth,
       center = fieldWidth / 2;

    let scale = workspace.getScale(),
      offset = workspace.getOffset();

    return {
      x: (posX * scale) + offset.x  - center,
      y: (posY * scale) + offset.y  - center
    };
  };

  onMouseUp = () => {
    if (EventManager.getCursor().indexOf("delete") >= 0 && this.mixin.movable.state.hovering) {
      this.delete();
    }
  };

  render = (ctx) => {
    let pointField = getPointField(this.posX, this.posY);
    let scale = config.scale;
    let width = this.mixin.movable.width * scale;
    let height = this.mixin.movable.height * scale;
    let radius = this.design.borderRadius;
    let fill = this.design.fillStyle;

    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = this.design.fillStyle;
    ctx.strokeStyle = this.design.strokeStyle;
    ctx.lineWidth = this.design.lineWidth;
    //ctx.shadowColor = this.design.shadowColor;
    //ctx.shadowBlur = this.design.shadowBlur;

    if(EventManager.getCursor().indexOf("delete") >= 0 && this.mixin.movable.state.hovering) {
      ctx.fillStyle = this.design.fillStyleDelete;
    }

    //ctx.rect(pointField.x, pointField.y, this.design.width * scale, this.design.height * scale);
    //ctx.rect(pointField.x, pointField.y, this.mixin.movable.width * scale, this.mixin.movable.height * scale);
    RenderFigures.roundedRect(ctx, pointField.x, pointField.y, width, height, radius, fill, true);

    ctx.stroke();
    ctx.fill();
    ctx.closePath();
    ctx.restore();
  };
}
